<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>

                <div v-if="this.isAgency() && evaluation_process !== false" class="row" id="agency">
                    <div class="col-12 mb-4">
                        <div class="col-lg-7 col-12 d-flex flex-column m-auto text-center price-evaluation">
                            <div class="d-flex justify-content-center">
                                <img class="mb-3" src="/images/tick_icon.svg" alt="tick_icon" width="50"/>
                            </div>
                            <label class="font-weight-bolder mb-2 request-completed">La tua richiesta è stata inviata correttamente. </label>
                            <label>Verrai ricontattato da un nostro consultente per ricevere un’offerta di acquisto e per fissare un eventuale sopralluogo all’immobile.</label>
                        </div>
                    </div>

                    <div class="col-12 m-auto text-center">
                        <a :href="route('agency.show_properties', this.user.agency_id)" class="">Vai alla tua pagina personale</a>
                    </div>
                </div>

                <div v-else-if="!this.isAgency() && evaluation_process !== false" class="row">
                    <div class="col-12 mb-1 d-flex justify-center text-center">
                        <img src="/images/property_icon.svg" alt="property_icon" />
                    </div>
                    <div class="col-12 mb-3 d-flex justify-center text-center">
                        <label>{{ address }}</label>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="col-lg-8 col-12 d-flex flex-column m-auto text-center price-evaluation">
                            <label class="font-weight-bolder mb-2">Il valore del tuo immobile è compreso tra</label>
                            <label class="colored-label font-weight-bolder price">{{ (expected_value - (expected_value * 0.1)).toLocaleString() }} € -
                                {{ (expected_value + (expected_value * 0.1)).toLocaleString() }} €</label>
                        </div>
                    </div>

                    <div class="col-12 mb-1">
                        <div class="col-lg-7 col-12 m-auto text-center">
                            <label class="font-weight-bolder colored-label">Ci dispiace ma non possiamo fare un’offerta per il tuo immobile.</label>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="col-lg-9 col-12  m-auto text-center">
                            <label>Sarai contattato a breve da un nostro collaboratore per avere un riscontro sulla valutazione ricevuta e,
                                se lo desideri, per aiutarti ad individuare un'agenzia immobiliare specializzata nella tua zona.</label>
                        </div>
                    </div>

                    <div class="col-12 mb-3">
                        <div class="col-lg-10 col-12 m-auto text-center">
                            <div class="separator"></div>
                        </div>
                    </div>

                    <div class="col-12 mb-1">
                        <div class="col-lg-7 col-12 m-auto text-center">
                            <label class="font-weight-bolder colored-label">Quando vorresti essere contattato?</label>
                        </div>
                    </div>

                    <div class="col-12 mb-3">
                        <div class="col-lg-9 col-12 m-auto text-center">
                            <label>Indicaci i giorni e l’orario in cui preferiresti ricevere la nostra chiamata</label>
                        </div>
                    </div>

                    <div class="col-12 mb-3">
                        <div class="col-lg-8 col-12 mb-2 m-auto">
                            <textarea class="form-control" name="contact-type" v-model="message_text" placeholder="Vorrei essere contattato dal lunedì al venerdì dopo le 18.00" rows="3"></textarea>
                        </div>
                    </div>

                    <div class="col-12 m-auto text-center">
                        <button type="button" class="btn btn-outline-primary mb-3" :disabled="isDisabled" @click="submit">Invia</button><br>

                        <a href="/" class="">Torna all'homepage</a>
                    </div>
                </div>

                <div v-else class="row" style="margin-top: 20%">
                    <div class="col-12 mb-4">
                        <div class="col-lg-7 col-12 d-flex flex-column m-auto text-center price-evaluation">
                            <div class="d-flex justify-content-center">
                                <img class="mb-3" src="/images/tick_icon.svg" alt="tick_icon" width="50"/>
                            </div>
                            <label class="font-weight-bolder mb-2 request-completed">La tua richiesta è stata inviata correttamente</label>
                            <label>Verrai ricontattato al più presto</label>
                        </div>
                    </div>

                    <div class="col-12 m-auto text-center">
                        <a href="/" class="">Torna alla homepage</a>
                    </div>
                </div>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>

            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>

import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data', 'user'],

    data() {
        return {
            step: 8,
            header_step: this.isAgency() ? 8 : 9,
            progress: 5,
            progress_title: this.isAgency() ? "Richiesta inviata con successo" : "Valutazione completata",
            progress_description: "Grazie per aver inviato la richiesta di valutazione.",
            message_text: "",
            property_id: localStorage.getItem('current_property_id'),
            expected_value: '',
            email: '',
            address: '',
            evaluation_process: false
        }
    },

    computed: {
        isDisabled() {
            return this.message_text.length <= 0;
        }
    },

    components: {
        Label,
        Button,
        WizardProgress,
        WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        submit(e) {
            axios.post('send-mail',{
                user_email: this.email,
                user_message: this.message_text
            })
            .then(response => {
                if (response.data.type === 'error') {
                    this.$toast.error(response.data.message)
                } else if (response.data.type === 'success') {
                    this.$toast.success(response.data.message)
                }
            })
            .catch(error => {
                this.$toast.error(error.response.data.message);
            })

            axios.put('/wizard/properties/' + this.property_id, {
                message_text: this.message_text
            }).catch(error => {
                console.log(error)
            })

            this.message_text = ""
            e.preventDefault();

            localStorage.removeItem('current_property_id')
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(), this.step, 'test', this.$inertia)

        if (this.isAgency()) return

        axios.get('/wizard/properties/' + this.property_id)
        .then(response => {
            this.expected_value = response.data.expected_value
            this.email = response.data.user_email

            this.address = response.data.address + ' ' + response.data.house_number + ', ' + response.data.postal_code + ' ' + response.data.municipality
        }).catch(error => {
            console.log(error)
        })
    }

}

</script>
